import * as React from "react";
export function SvgSpacesMastheadExternalServer(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      id="Spaces_Masthead_External_Server_svg__Layer_1"
      x={0}
      y={0}
      width={60}
      height={60}
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          ".Spaces_Masthead_External_Server_svg__st0{fill:#6e6f72}.Spaces_Masthead_External_Server_svg__st1{fill:#b3b3b5}"
        }
      </style>
      <path
        className="Spaces_Masthead_External_Server_svg__st0"
        d="M43 23v13H2V23h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V23c0-.5-.5-1-1-1z"
      />
      <path
        className="Spaces_Masthead_External_Server_svg__st0"
        d="M43 37v13H2V37h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V37c0-.5-.5-1-1-1zM43 9v13H2V9h41m0-1H2c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h41c.6 0 1-.4 1-1V9c0-.6-.5-1-1-1z"
      />
      <path
        className="Spaces_Masthead_External_Server_svg__st1"
        d="M27 14h10v3H27zM27 28h10v3H27zM27 42h10v3H27z"
      />
    </svg>
  );
}
